import React, { useEffect } from 'react';
import { useGdprConsent } from 'hooks/useGdprConsent';
import { CookieType } from 'components/Gdpr/enums/CookieType';

const ConsentHandler = (): JSX.Element => {
    const { isFinished, hasConsent } = useGdprConsent();

    useEffect(() => {
        if (isFinished) {
            const gdprScriptNodes = document.querySelectorAll('script[type="text/x-magento-gdpr"]');

            gdprScriptNodes.forEach((scriptElement) => {
                const cookieCode = scriptElement.getAttribute('data-consent');

                if (hasConsent(cookieCode as CookieType)) {
                    const approvedScriptElement = document.createElement('script');
                    approvedScriptElement.setAttribute('type', 'text/javascript');
                    approvedScriptElement.innerHTML = scriptElement.innerHTML;

                    scriptElement.after(approvedScriptElement);

                    if (scriptElement.parentElement) {
                        scriptElement.parentElement.removeChild(scriptElement);
                    }
                }
            });
        }
    }, [isFinished]);

    return <React.Fragment />;
};

export default ConsentHandler;
